module.exports = __webpack_public_path__ + "img/list.c04b2773.svg";